import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
import * as fromRouter from '~core/store';
import { combineLatest, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { ErrorResponse } from '~shared/modules/error-handler';
import { PageDetectionUtil } from '~shared/utils/page-detection.util';
import {
  HubActionTypes,
  LoadCustomHubConfigContent,
  LoadCustomHubConfigContentFailure,
  LoadCustomHubConfigContentSuccess
} from './hub.actions';
import { Hub } from '~app/modules/custom-hub/models';
import { HubService } from '~app/modules/custom-hub/services';

@Injectable({
  providedIn: 'root'
})
export class HubEffects {
  private activeRoute$ = this.store.pipe(select(fromRouter.getRouterState));

  constructor(
    private actions$: Actions,
    private store: Store<fromRouter.RouterState>,
    private hubService: HubService
  ) {}

  @Effect()
  loadCustomHubContent$: Observable<Action> = this.actions$.pipe(
    ofType(HubActionTypes.LOAD_HUB_CONFIG_CONTENT),
    map((action: LoadCustomHubConfigContent) => action.payload.pageName),
    switchMap((pageName: string) =>
      this.hubService.getCustomHubConfig(pageName).pipe(
        map(
          (hub: Hub) =>
            new LoadCustomHubConfigContentSuccess({ hub })
        ),
        catchError((error: ErrorResponse) =>
          of(new LoadCustomHubConfigContentFailure({ error }))
        )
      )
    )
  );

  @Effect()
  loadCustomHubContentByRoute$: Observable<Action> = combineLatest([
    this.activeRoute$
  ]).pipe(
    filter(([routeState]) => {
      if (!routeState) {
        return false;
      }
      return routeState.url &&
        PageDetectionUtil.isCustomCategoryHubPage(routeState.url);
    }),
    map(([routeState]) => {
      return routeState.url.substring(routeState.url.lastIndexOf('/') + 1);
    }),
    switchMap(pageName => {
      return of(new LoadCustomHubConfigContent({ pageName }));
    })
  );
}
